var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.isLogin && _vm.route_params.org_id && _vm.$route.path.includes('page_editor') === false)?_c('AppSidebar'):_vm._e(),(_vm.isLogin === true && _vm.route_params.org_id)?_c('v-main',[_c('v-container',{class:{
        'pa-0': _vm.$route.path.includes('page_editor') === true,
      },staticStyle:{"height":"100%"},attrs:{"fluid":""}},[(_vm.is_page_loading)?_c('PageLoader'):_c('router-view')],1)],1):_c('router-view'),_c('vtoast',{ref:"vtoast"}),_c('vprogress',{ref:"vprogress"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }